module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by-bk-duncan"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-bk-duncan-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also by BK Duncan")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-bk-duncan-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he stunning second")]), _vm._v(" instalment in the May Keaps "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("series")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('i', [_vm._v("Found Drowned")]), _c('i'), _vm._v("( May Keaps Book "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("2")]), _vm._v(")")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("B")]), _vm._v("K Duncan")]), _vm._v(" also writes as Ruth Wade and you will also enjoy her unmissable historical thriller, "), _c('i', [_vm._v("Walls of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Silence")])]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de92abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-bk-duncan.vue
// module id = 69
// module chunks = 0